<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: {
                type: Number,
                default: 0,
            },
            valueCurrency: {
                type: Number,
                default: 0,
            },
            cLabel: {
                type: String,
                default: 'IsoCode'
            },
            cLabelOptions: {
                type: String,
                default: 'label'
            },
            cDisabled: {
                type: Boolean,
                default: false,
            },
            currency: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            fixed: {
                type: Number,
                default: 2
            },
            min: {
                type: Number,
                default: -999999999999
            },
            max: {
                type: Number,
                default: 999999999999
            },
        },
        data() {
            return {
                val: 0,
                cur: 1,
                f: false,
                fs: false,
                old: 0,
                oldc: 0,
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/currency/get_list'
            }),
            event_load() {
                if (this.currency) this.$emit('load', this.load);
            },
            input_focus() {
                this.f = true;
                this.val = this.validateVal(this.val);
                this.$nextTick(() => {
                    let start = this.$refs.input.selectionStart;
                    console.log(start);
                })
            },
            input_blur() {
                if (this.val !== this.old) this.$emit('change', this.val ? +this.val.replace(/ /g, '') : 0);
                this.old = +(this.val.replace(/ /g, ''));
                this.f = false;
                this.val = this.validateVal(this.val);
            },
            input_update(v) {
                if (!this.f) return;
                let start = this.$refs.input.selectionStart;
                let a = this.validateVal(v);
                let b = this.val;
                let aa = a.slice(0, start);
                let bb = b.slice(0, start);
                let aaa = a.split(' ').length;
                let bbb = b.split(' ').length;
                start += aaa - bbb;
                start = start >= 0 ? start : start;
                if(a[0] === '.'){
                    a = '0' + a ;
                    start++;
                }
                this.val = a;
                this.$refs.input.value = a;

                this.$nextTick(() => {
                    this.$refs.input.selectionStart = start;
                    this.$refs.input.selectionEnd = start;
                });
            },
            select_focus() {
                this.fs = true;
            },
            select_blur() {
                if (this.cur !== this.oldc)
                    this.oldc = this.cur;

                this.fs = false;
            },
            validateVal(v) {
                let a = (v + '').replace(/,/g, '.').replace(/[^0-9\.]/g, '').replace(/^([^\.]*\.)|\./g, '$1');
                if (a[0] && a[0] === '0' && a[1] && a[1] !== '.') a = a.replace('0', '');
                if (this.fixed > 0) {
                    let b = a.split('.');
                    if (b[1] && b[1].length > 2) a = b[0] + '.' + (b[1].slice(0, this.fixed));
                }
                if (this.fixed === 0) {
                    a = a.split('.')[0];
                }
                if (+a < this.min) a = this.val;
                if (+a > this.max) a = this.val;
                a = a.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
                return a;
            }
        },
        computed: {
            ...mapState('dictionary/currency', {
                load: 'load',
                list: 'list'
            }),
            ...mapGetters('dictionary/currency', {
                national: 'national',
                getById: 'getById',
            }),

        },
        watch: {
            currency(v) {
                if (v) this.get_list();
            },
            load() {
                this.event_load();
            },
            value(v) {
//                this.val = this.validateVal(v.toString());
                if (!this.f) {
                    this.old = v;
                }
            },
            valueCurrency(v) {
                this.cur = v;
                if (!this.fs) this.oldc = v;
            },
            val(v) {
                this.$emit('input', +(this.val.replace(/ /g, '')));
            },
            cur(v) {
                this.$emit('update:valueCurrency', v);

            },
        },
        components: {},
        mounted() {
            this.val = '' + this.value;
            this.val = this.val.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
            if (this.currency) this.get_list();
            this.event_load();

        },
        destroyed() {

        },
    }
</script>
<template>
        <div class="input-test" :class="{'is-disabled':disabled}">
            <div class="el-input el-input--mini el-input-group el-input-group--prepend" :class="{'is-disabled':disabled}">
                <div class="el-input-group__prepend" >
                    sadsadsa
                </div>
                <el-select v-model="cur" class="input-price__currency" :disabled="cDisabled||disabled" :title="getById(cur)?getById(cur)[cLabelOptions]:''">
                    <el-option v-for="item in list" :key="item.value" :value="item.value" :label="item[cLabel]||''">{{item[cLabelOptions]}}</el-option>
                </el-select>
            </div>
            <div class="input-price__load" v-show="(load&&currency)">
                <i class="el-icon-loading"></i> Загрузка...
            </div>
        </div>
</template>
